module.exports = __webpack_public_path__ + "static/media/Thomas.eb7a6b95.png";